import * as ng from 'angular';
import * as _ from 'underscore';

export class DropdownController {
   ngModelCtrl:ng.INgModelController;
   placeholder:string;

   choices:DropdownChoiceController[] = [];

   get buttonText() {
      // no condition on $modelValue to test for truthy since null might be
      // valid value, i.e. the default option
      let choice = _.findWhere(this.choices, {value: this.ngModelCtrl.$modelValue});
      if (choice) {
         return choice.label;
      }

      return this.placeholder;
   }

   selected(value:any) {
      return this.ngModelCtrl.$modelValue == value;
   }

   select(value:any) {
      this.ngModelCtrl.$setViewValue(value);
   }
}

export class DropdownChoiceController {
   dropdownCtrl:DropdownController;
   value:any;
   label:string;

   $onInit() {
      this.dropdownCtrl.choices.push(this);
   }
}

ng.module('e360').component('dropdown', {
   templateUrl: require('./dropdown.html'),
   controller: DropdownController,
   transclude: true,
   bindings: {
      placeholder: '@'
   },
   require: {
      ngModelCtrl: 'ngModel'
   }
});

ng.module('e360').component('dropdownChoice', {
   controller: DropdownChoiceController,
   bindings: {
      value: '<',
      label: '<'
   },
   require: {
      dropdownCtrl: '^dropdown'
   }
});
